(() => {
  function setup(header) {
    const panel = header.querySelector('[data-search-panel]');
    const trigger = header.querySelector('[data-search-open]');
    if (!panel || !trigger || header.dataset.searchReady) return;
    header.dataset.searchReady = 'true';
    const input = panel.querySelector('[data-search-input]');
    const form = panel.querySelector('[data-search-form]');
    const results = panel.querySelector('[data-search-results]');
    const recommendations = panel.querySelector('[data-search-recommendations]');
    const status = panel.querySelector('[data-search-status]');
    const backdrop = header.querySelector('.cft-search-backdrop');
    const cards = [...recommendations.querySelectorAll('[data-search-card]')];
    const menu = header.querySelector('.cft-mobile-menu');
    const preview = new URL(panel.dataset.previewUrl || '/', location.origin).searchParams.get('preview_theme_id');
    let timer, request, sequence = 0, priorOverflow, inertRoots = [];
    const position = () => header.style.setProperty('--cft-search-top', `${Math.max(0, header.getBoundingClientRect().bottom)}px`);
    function close() {
      if (panel.hidden) return;
      panel.hidden = backdrop.hidden = true;
      trigger.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = priorOverflow;
      inertRoots.forEach(node => { node.inert = false; });
      inertRoots = [];
      clearTimeout(timer);
      request?.abort();
      sequence++;
      trigger.focus({preventScroll: true});
    }
    function open() {
      if (!panel.hidden) return close();
      menu?.removeAttribute('open');
      position();
      priorOverflow = document.body.style.overflow;
      document.body.style.overflow = 'hidden';
      inertRoots = [...document.body.children].filter(node => !node.contains(header) && !node.inert && node.matches('main,.shopify-section-group-footer-group,footer'));
      inertRoots.forEach(node => { node.inert = true; });
      panel.hidden = backdrop.hidden = false;
      trigger.setAttribute('aria-expanded', 'true');
      input.focus({preventScroll: true});
      search();
    }
    function render(content, query, failed = false) {
      const grid = content.querySelector('[data-search-result-grid]');
      const existing = [...grid.querySelectorAll('[data-search-card]')];
      existing.forEach(card => {
        const known = cards.find(item => item.dataset.searchHandle && item.dataset.searchHandle === card.dataset.searchHandle);
        if (known) card.replaceWith(known.cloneNode(true));
        else if (preview) {
          const link = card.querySelector('a');
          const url = new URL(link.getAttribute('href'), location.origin);
          url.searchParams.set('preview_theme_id', preview);
          link.href = url.pathname + url.search;
        }
      });
      cards.filter(card => card.dataset.searchTerms.toLowerCase().includes(query.toLowerCase())).forEach(card => {
        if (![...grid.children].some(item => item.dataset.searchKey === card.dataset.searchKey)) grid.append(card.cloneNode(true));
      });
      const count = grid.children.length;
      results.replaceChildren(content);
      results.dataset.searchQuery = query;
      results.hidden = false;
      recommendations.hidden = count > 0;
      status.textContent = failed ? 'Search is temporarily unavailable. You can explore these products.' : count ? '' : `No products found for “${query}”. Try another word.`;
      results.setAttribute('aria-busy', 'false');
    }
    async function search() {
      clearTimeout(timer);
      request?.abort();
      const current = ++sequence;
      const query = input.value.trim();
      if (!query) {
        results.replaceChildren();
        results.dataset.searchQuery = '';
        results.hidden = true;
        recommendations.hidden = false;
        status.textContent = '';
        results.setAttribute('aria-busy', 'false');
        return;
      }
      request = new AbortController();
      results.setAttribute('aria-busy', 'true');
      status.textContent = 'Searching…';
      const url = new URL(panel.dataset.searchUrl, location.origin);
      url.searchParams.set('section_id', 'crftop-search-results');
      url.searchParams.set('q', query);
      url.searchParams.set('type', 'product');
      url.searchParams.set('options[prefix]', 'last');
      if (preview) url.searchParams.set('preview_theme_id', preview);
      try {
        const response = await fetch(url.pathname + url.search, {signal: request.signal});
        if (!response.ok) throw new Error('Search request failed');
        const parsed = new DOMParser().parseFromString(await response.text(), 'text/html');
        const content = parsed.querySelector('[data-search-response]');
        if (!content?.querySelector('[data-search-result-grid]')) throw new Error('Search response missing');
        if (current === sequence && !panel.hidden) render(content, query);
      } catch (error) {
        if (error.name === 'AbortError' || current !== sequence || panel.hidden) return;
        const content = document.createElement('div');
        content.innerHTML = '<h3>Search results</h3><div class="cft-search-grid" data-search-result-grid></div>';
        render(content, query, true);
      }
    }
    trigger.addEventListener('click', open);
    header.querySelectorAll('[data-search-close]').forEach(button => button.addEventListener('click', close));
    form.addEventListener('submit', event => { event.preventDefault(); search(); });
    input.addEventListener('input', () => {
      request?.abort();
      sequence++;
      clearTimeout(timer);
      if (!input.value.trim()) search();
      else timer = setTimeout(search, 200);
    });
    panel.addEventListener('keydown', event => {
      if (event.key === 'Escape') { event.preventDefault(); close(); }
      if (event.key !== 'Tab') return;
      const focusable = [...panel.querySelectorAll('a,button,input')].filter(node => !node.disabled && node.getClientRects().length);
      const first = focusable[0], last = focusable.at(-1);
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last?.focus(); }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first?.focus(); }
    });
    menu?.addEventListener('toggle', () => { if (menu.open) close(); });
    document.addEventListener('click', event => {
      const link = event.target.closest('a[href]');
      if (!link || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
      const url = new URL(link.href);
      if (url.origin === location.origin && url.pathname === panel.dataset.searchUrl && !url.searchParams.get('q')) {
        event.preventDefault();
        if (!panel.hidden) close();
        open();
      }
    });
    window.addEventListener('resize', position);
    document.addEventListener('shopify:section:unload', event => { if (event.target.contains(header)) close(); });
  }
  const init = root => root.querySelectorAll('[data-search-header]').forEach(setup);
  init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
